import { render, staticRenderFns } from "./ScreenBig.vue?vue&type=template&id=579cbbe4&"
import script from "./ScreenBig.vue?vue&type=script&lang=ts&"
export * from "./ScreenBig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports